import React from "react";
import CessionCaptureStatistics from "./cession-capture";
import CessionProduitStatistics from "./cession-produit";
import DemandeExportStatistics from "./demande-export";

export default () => {
    return (<>
        <CessionCaptureStatistics />
        <CessionProduitStatistics />
        <DemandeExportStatistics />

        {/* <Grid stackable columns="3" >
    <Grid.Column>
        <Components.Regions.RegionWithHeader
          title="label.entite-rattachement"
          headerColor="blue"
          headerSize="small"
          className="dash-region"
        >
          <Components.Dashboard.ChangeEntiteRattachement />
        </Components.Regions.RegionWithHeader>
      </Grid.Column>
      <Grid.Column>
        <Components.Regions.RegionWithHeader
          title="label.download"
          headerColor="blue"
          headerSize="small"
          className="dash-region"
        >
          <List divided animated className="dashboard-links download" relaxed>
            <List.Item>
              <Image src={Assets.Images.doc_icon} size="tiny" centered />
              <List.Content>
                <Link to={"#"}>
                  <FormattedMessage id="label.fiche-demande-export" />
                </Link>
              </List.Content>
              <List.Icon
                name="chevron right"
                color="blue"
                size="small"
                verticalAlign="middle"
              />
            </List.Item>
            <List.Item>
              <Image src={Assets.Images.doc_icon} size="tiny" centered />
              <List.Content>
                <Link to={"#"}>
                  <FormattedMessage id="label.fiche-reclamation" />
                </Link>
              </List.Content>
              <List.Icon
                name="chevron right"
                color="blue"
                size="small"
                verticalAlign="middle"
              />
            </List.Item>
          </List>
        </Components.Regions.RegionWithHeader>
      </Grid.Column>
  </Grid> */}
    </>);
};
